if (!customElements.get('daily-countdown-clock')) {
  customElements.define('daily-countdown-clock', class extends HTMLElement {
    connectedCallback() {
      clearTimeout(this.timer);
      this.fields = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-unit="${unit}"], [data-countdown-${unit}]`));
      this.refresh = () => {
        clearTimeout(this.timer);
        const now = Date.now();
        const hour = Number(this.dataset.resetHour);
        const offset = Number(this.dataset.utcOffset) * 3600000;
        const day = 86400000;
        const boundary = Math.floor((now + offset) / day) * day + hour * 3600000 - offset;
        const end = boundary > now ? boundary : boundary + day;
        const remaining = Math.ceil((end - now) / 1000);
        const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
        this.fields.forEach((field, index) => {
          if (field) field.textContent = String(values[index]).padStart(2, '0');
        });
        this.timer = setTimeout(this.refresh, 1000 - Date.now() % 1000);
      };
      this.refresh();
      document.addEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
  });
}
